import React from 'react';

const UserBox = ({ userId, wallet }) => {
  return (
    <div className="user-box">
      <div className="user-detail">
        <span className="user-label">User ID:</span>
        <span className="user-value" id="userId">{userId || 'N/A'}</span>
      </div>
      <div className="user-detail">
        <span className="user-label">Wallet:</span>
        <span className="user-value" id="userWallet">{wallet}</span>
      </div>
    </div>
  );
};

export default UserBox;
